import styled from 'styled-components'

export const PhotoUploadContainer = styled.div`
  margin: 0 auto;

  @media (min-width: 768px) {
    max-width: 500px;
  }
`

export const InfoContainer = styled.div`
  margin-bottom: 2rem;
  h2 {
    font-size: 1rem;
    margin: 0.5rem 0;
  }

  ul {
    list-style: outside;
    margin-left: 1.25rem;
  }

  li {
    font-size: 0.85rem;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const InitialButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const ModalContainer = styled.div`
  max-width: 300px;
  text-align: center;
  padding: 1rem;

  h2 {
    margin-bottom: 1rem;
  }

  h2,
  p {
    font-family: ${(props) => props.theme?.mainFontTheme || 'Lato'};
  }

  @media (min-width: 900px) {
    max-width: 600px;
    padding: 3rem;
  }
`

export const PatientConfirmationContainer = styled.div``

export const PatientVerificationContainer = styled.div`
  padding: 0.5rem;
  max-width: 400px;
  margin: 0 auto;

  h2 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    font-weight: 500;
  }

  h3,
  p {
    font-size: 1rem;
  }

  h3 {
    margin: 0 0 1rem 0;
  }

  @media (min-width: 768px) {
    margin: 0 auto;
  }
`

export const PatientUploadContainer = styled.div`
  padding: 1rem;
  width: 100%;
  margin: 0 auto;

  ${(props) =>
    props.theme?.mainFontTheme &&
    `
    h1, h2, h3, h4, h5, 
    a, p, li, span, button,
    label, td, th
    {
      font-family: ${props.theme?.mainFontTheme || 'Lato'};
    }
  `}
`
